import React from 'react'

import styles from './button-panel.module.css'

/**
 * @author Marissa Vargas
 * @date 2025-08-20
 * @description The ButtonPanel renders a panel of buttons from a given array.
 * @param {Array<{ show: boolean, action: function, image: string, label: string }>} buttons - An array of button objects, each containing properties like `show`, `action`, `image`, and `label`. 
 * @returns {JSX.element}
 * @example
 * ```jsx
 * <ButtonPanel
 *  buttons={[
 *    {
        show: true,
        action: () => onHandleBack(),
        image: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_SIGN_REQUEST}`,
        label: t("button.return")
      },
      {
        show: showBtnReject,
        action: () => handleReject(),
        image: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_SIGN_REQUEST}`,
        label: labelBtnReject
      }
    />
 * ```
 */
function ButtonPanel({ buttons }) {
  return (
    <section className={styles.main}>
      {buttons.map(
        (button, index) =>
          button.show && (
            <button className={styles.btns} key={index} onClick={button.action}>
              <img
                alt=''
                aria-hidden='true'
                src={button.image}
                height='24'
                width='24'
              />
              <span>{button.label}</span>
            </button>
          )
      )}
    </section>
  )
}

export default ButtonPanel
